import React from "react";

interface NoProjectBannerProps {
  show?: boolean;
  canEdit?: boolean;
  onAdd?: () => void;
}

const NoProjectBanner: React.FC<NoProjectBannerProps> = ({ show = false, canEdit = false, onAdd }) => {
  if (!show) return null;

  return (
    <div
      className="ds-notification p-6! !mb-[24px]"
      data-ds-variant="Info"
      data-ds-version="1"
      data-ds-theme="vessel"
      aria-labelledby="no-project-banner-title"
      style={{ border: '1px solid var(--Color-Blue-Deep, #003B71)', borderRadius: '8px', width: '55%' }}
    >
      <div className="ds-notification__icon" style={{ marginTop: '-8px', background: 'none', boxShadow: 'none' }}>
        <img
          src="/assets/images/informationIcon.svg"
          alt="Information"
          style={{ width: '40px', height: '40px' }}
        />
      </div>
      <div className="ds-notification__main-icon">
        <div className="ds-notification__header flex flex-col">
          <div
            className="ds-notification__heading p1 -medium !mb-0"
            id="no-project-banner-title"
            style={{ color: 'var(--Color-Inky, #0D1C3D)', lineHeight: '24px' }}
          >
            No performance Projects have been added to this team
          </div>

          {canEdit && (
            <div className="mt-8!">
              <button
                aria-label="Toggle Add Project"
                className={`button py-0! flex items-center group hover:text-white! focus:text-white!`}
                onClick={() => (onAdd ? onAdd() : console.log("Add New Project"))}
              >
                <img
                  src="/assets/images/plus-outline.svg"
                  alt="Plus icon"
                  className="w-6 h-6 group-focus:brightness-0! group-focus:invert! group-hover:brightness-0! group-hover:invert!"
                />
                {' '}
                Add new Project
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NoProjectBanner;
